// extracted by mini-css-extract-plugin
export var addButton = "_f4-0";
export var border = "_f4-8";
export var check = "_f4-h";
export var danger = "_f4-6";
export var dropdownContainer = "_f4-1";
export var editModalBody = "_f4-j";
export var footerContainer = "_f4-i";
export var fullWidth = "_f4-a";
export var hide = "_f4-9";
export var icon = "_f4-3";
export var input = "_f4-7";
export var inputFlex = "_f4-b";
export var inputWrapper = "_f4-c";
export var manualFocus = "_f4-5";
export var optionButton = "_f4-4";
export var pillWrapper = "_f4-e";
export var pointer = "_f4-2";
export var showOverflow = "_f4-f";
export var tagsFlex = "_f4-d";
export var xButton = "_f4-g";